import { action } from 'typesafe-actions';

export enum DashboardActions {
  GET_FILES = 'Dashboard/GET_FILES',
  GET_FILES_DONE = 'Dashboard/GET_FILES_DONE',
  DASHBOARD_ERROR = 'Dashboard/DASHBOARD_ERROR',
}

export const getFiles = (): { type: DashboardActions.GET_FILES } => action(DashboardActions.GET_FILES);
